import { GlobalState, UI } from '@leverege/ui-redux';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SHOW_OVERLAYS_KEY } from "../../../Constants.js";
export default function useOverlayKeyBindings() {
  const showOverlays = useSelector(state => {
    const show = UI.get(state, SHOW_OVERLAYS_KEY);
    return show == null ? true : show;
  });
  const onToggleOverlays = useCallback(evt => {
    if (evt.key === 'o') {
      GlobalState.dispatch(UI.set(SHOW_OVERLAYS_KEY, !showOverlays));
    }
  }, [showOverlays]);
  useEffect(() => {
    window.addEventListener('keydown', onToggleOverlays);
    return () => {
      window.removeEventListener('keydown', onToggleOverlays);
    };
  }, [onToggleOverlays]);
  useEffect(() => {
    return () => {
      GlobalState.dispatch(UI.set(SHOW_OVERLAYS_KEY, true));
    };
  }, []);
}